export default __webpack_public_path__ + "static/media/account-plus-outline.7802f4af.svg";